import React from 'react';

import type { Logo } from 'client-ribbons-design-system/types/logo';

export const IconPaymentMastercard = ({ height = '32', width = '50' }: Logo) => (
  <svg
    data-testid="icon-payment-mastercard"
    height={height}
    viewBox="0 0 50 32"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Mastercard logo</title>
    <g fill="none" fillRule="evenodd">
      <rect fill="#FFF" height="32" rx="6" width="50" />
      <path d="M20.713 24.236h9.423V7.303h-9.423z" fill="#FF5F00" />
      <path
        d="M21.311 15.77a10.75 10.75 0 0 1 4.113-8.467c-4.676-3.676-11.446-2.864-15.121 1.812-3.676 4.675-2.864 11.446 1.812 15.121a10.769 10.769 0 0 0 13.31 0 10.75 10.75 0 0 1-4.114-8.467"
        fill="#EB001B"
      />
      <path
        d="M42.848 15.77c0 5.947-4.821 10.768-10.768 10.768a10.77 10.77 0 0 1-6.656-2.302c4.676-3.677 5.486-10.448 1.81-15.124a10.768 10.768 0 0 0-1.81-1.81C30.1 3.629 36.87 4.439 40.545 9.115a10.77 10.77 0 0 1 2.303 6.655z"
        fill="#F79E1B"
      />
      <path
        d="M43 23.051v-1h-.209l-.24.688-.24-.688h-.208v1h.147v-.754l.225.65h.153l.225-.652v.756H43zm-1.25 0v-.83h.353v-.17h-.898v.17h.353v.83h.192z"
        fill="#F79E1B"
      />
      <g stroke="#AEBCC6">
        <rect height="31" rx="6" width="49" x=".5" y=".5" />
      </g>
    </g>
  </svg>
);
